<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    title="选择地点"
    width="40%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
             <el-form-item label="选择地点" prop="pointName">
               <div style="display: flex;align-items: center;">
                <select-city v-model="rowInfo.cityCode" placeholder="选择城市" style="width: 110px"/>
                <el-autocomplete
                    v-model="rowInfo.pointName"
                    popper-class="autoAddressClass"
                    :fetch-suggestions="querySearchAsync"
                    :trigger-on-focus="false"
                    placeholder="输入搜索地点"
                    clearable
                    @select="handleStartSelect"
                    style="width:300px;"
                >
                  <template slot-scope="{ item }">
                    <i class="el-icon-search fl mgr10" />
                    <div style="overflow:hidden;">
                      <div class="title">{{ item.title }}</div>
                      <span class="address ellipsis">{{ item.address }}</span>
                    </div>
                  </template>
                </el-autocomplete>
               </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">确定</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import SelectCity from '@/components/SelectCity/index.vue'
import {placeSearch} from "@/api/wayz";
import { citys } from  "@/const/city"
export default {
  components: {
    SelectCity
  },
  data() {
    var checkAddress = (rule, value, callback) => {
      if (this.rowInfo.pointLatitude==''||this.rowInfo.pointLongitude=='') {
        callback(new Error('请选择地址'));
      }
      callback();
    };
    return {
      visible: false,
      formName: '新增',
      locationPoint: null,
      pointsList:[],
      points:[],
      canUse:true,    //校验点坐标重叠标识
      loading: false,
      current: '',
      rowInfo: {
        cityCode:'',
        cityName:'',
        pointName: '',
        pointLongitude:'',
        pointLatitude:''
      },
      rules: {
        pointName: [{ required: true, message: '请选择地点', trigger: 'blur' },
          { validator: checkAddress, trigger: 'change' }
        ],
      }
    }
  },
  //这里运用async/await 进行异步处理，保证BMap加载进来后才执行后面的操作
  async mounted() {
  },
  methods: {
    init(current,cityCode) {
      this.current = current
      this.rowInfo.cityCode = cityCode;
      this.visible = true
    },
    //地址搜索
    async querySearchAsync(str, cb) {
      if (!this.rowInfo.cityCode){
        this.$message.warning("请选择城市");
        return;
      }
      let cityName = citys.find(item => item.codeItemId == this.rowInfo.cityCode).codeName
      this.rowInfo.cityName = cityName
      let {data: res} = await placeSearch(str,cityName);
      if(res.code==0){
        let s = []
        for (let i = 0; i < res.data.length; i++) {
          s.push({
            address: res.data[i].name,
            longitude: res.data[i].geoPoint.split(',')[0],
            latitude: res.data[i].geoPoint.split(',')[1],
          })
        }
        cb(s)
      }else{
        cb([])
      }
    },
    //选择地址
    handleStartSelect(item) {
      this.rowInfo.pointName = item.address;
      this.rowInfo.pointLongitude =item.longitude;
      this.rowInfo.pointLatitude =item.latitude;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
             // 子组件中触发父组件的初始化方法
             this.$emit('refresh', this.current,JSON.parse(JSON.stringify(this.rowInfo)));
             // 关闭弹框
             this.closeForm()
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.current = ''
      this.rowInfo = {
        cityCode: '',
        cityName: '',
        pointName: '',
        pointLongitude:'',
        pointLatitude:''
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
